import React from 'react'; 

const containerSecondaryRight = (props) => (
    <div className={`u-flex justify-content-between f-wrap`}>
        {props.children}
    </div>
);

export default containerSecondaryRight;


// WEBPACK FOOTER //
// ./src/components/Flight/UI/Mobile/Tuple/ContainerSecondaryRight/ContainerSecondaryRight.js